import {Component, OnInit} from '@angular/core';
import {LoadingController, ModalController, NavController, NavParams, ToastController} from '@ionic/angular';
import {ServerService} from '../../service/server.service';
import {AdminService} from '../../service/admin.service';

@Component({
  selector: 'app-advertising-add',
  templateUrl: './advertising-add.page.html',
  styleUrls: ['./advertising-add.page.scss'],
})
export class AdvertisingAddPage implements OnInit {

  text: any;
  name: any;
  phone: any;
  email: any;
  address: any;
  id: any;
  loading: any;
  fileUrl: string;
  fileType: string;

  constructor(public navParams: NavParams,
              public loadingController: LoadingController,
              public server: ServerService,
              public nav: NavController,
              public toastController: ToastController,
              public modalController: ModalController,
              private adminService: AdminService) {
  }

  async ngOnInit() {
    this.loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 30000
    });
  }

  async saveData(data) {
    data.url = this.fileUrl;
    data.type = this.fileType;
    this.loading.present();
    console.log('data', data);
    this.adminService.createAdvertisements(data).subscribe((res) => {
      this.presentToast('Archivo cargado con éxito');
      this.close(true);
    }, error => {
      console.warn('Error al crear Perfil', error);
      this.loading.dismiss();
      this.presentToast(error.error.error);
    });
  }

  async close(data?: any) {
    await this.modalController.dismiss(data);
  }

  async presentToast(txt) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 3000,
      position: 'top',
      mode: 'ios',
      color: 'dark'
    });
    toast.present();
  }

  changeFile(event: any) {
    this.loading.present();
    if (event.target.files[0]) {
      this.fileType = event.target.files[0].type;
      console.log(event.target.files[0]);
      this.adminService.uploadFile(event.target.files[0], 'advertising').subscribe((res: any) => {
        this.fileUrl = res.url;
        this.loading.dismiss();
      }, error => {
        console.warn(error);
        this.loading.dismiss();
      });
    }
  }
}
